export type ImageProps = {
  src: string
  aspect?: ImageAspect
  alt?: string
  css?: any
}

export enum ImageAspect {
  Square = "square",
  Landscape = "landscape"
}
